import { postSlackMessageSend, PostSlackMessageSendReq } from 'lib/api/slackMessageSend/postSlackMessageSend'
import { useMutation } from 'react-query'

export default function usePostSlackMessageSend() {
  return useMutation((value: PostSlackMessageSendReq) => postSlackMessageSend(value), {})
}
